import React from "react";
import chain1 from "./Image/Conveyor-chain-type-1.jpg";
import chain2 from "./Image/Conveyor-chain-type-2.jpg";
import chain3 from "./Image/Conveyor-chain-type-3.jpg";
import chain4 from "./Image/Conveyor-chain-type-4.jpg";
import chain5 from "./Image/Conveyor-chain-type-5.jpg";
import chain6 from "./Image/Slat-Conveyor-chain-type-6.jpg";
import "./Automobile.css";

const Automobile = () => {
  return (
    <div>
      <div className="automobilep">
        <p className="p">Automobile</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Automobile</p> */}
        </div>
      </div>

      <div className="automobile">
        <div className="auimg">
          <figure>
            <img className="chain-one" src={chain1} alt="chain type 1" />
            <figcaption>Conveyor Chain Type 1</figcaption>
          </figure>
        </div>

        <div className="auimg">
          <figure>
            <img src={chain2} alt="chain type 2" />
            <figcaption>Conveyor Chain Type 2</figcaption>
          </figure>
        </div>

        <div className="auimg">
          <figure>
            <img src={chain3} alt="chain type 3" />
            <figcaption>Conveyor Chain Type 3</figcaption>
          </figure>
        </div>

        <div className="auimg">
          <figure>
            <img src={chain4} alt="chain type 4" />
            <figcaption>Conveyor Chain Type 4</figcaption>
          </figure>
        </div>
      </div>

      <div className="automobile-two">
        <div className="auimg">
          <figure>
            <img src={chain5} alt="chain type 5" />
            <figcaption>Conveyor Chain Type 5</figcaption>
          </figure>
        </div>

        <div className="auimg">
          <figure>
            <img src={chain6} alt="chain type 6" />
            <figcaption>Slate Conveyor Chain Type 6</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Automobile;
